"use strict";

(function ($) {
  'use strict';

  // check namespace
  $.b2b = $.b2b || {};
  var Widget = function Widget() {
    var me = this;
    me.popover = null;
    me.favouriteService = {
      last: function last() {
        return $.ajax('/FavouritePage/GetLastAndSettings', {
          cache: false,
          dataType: 'json',
          method: 'GET',
          traditional: true
        });
      },
      remove: function remove(id) {
        return $.ajax('/FavouritePage/Remove', {
          data: {
            favouritePageId: id
          },
          dataType: 'json',
          method: 'POST',
          traditional: true
        });
      },
      add: function add(pageName, pageUrl) {
        return $.ajax('/FavouritePage/Add', {
          data: {
            name: pageName,
            url: pageUrl
          },
          dataType: 'json',
          method: 'POST',
          traditional: true
        });
      },
      hideSettings: function hideSettings() {
        return $.ajax('/FavouritePage/SaveSettings', {
          data: {
            ShowFavouritePagesWidget: false
          },
          dataType: 'json',
          method: 'POST',
          traditional: true
        });
      }
    };
    me.options = {
      $el: null,
      $list: null,
      $down_up: null,
      $add_pane: null,
      $del_pane: null,
      $del_btn: null,
      $add_btn: null,
      $cancel_btn: null,
      $hide_btn: null,
      $setFvr_btn: null,
      $add_name: null,
      $linksbox: null,
      $icondown: null,
      $selectedPositionList: null
    };
    me.updating = false;
    me.updating_callback = null; // функция, которую надо запустить после загрузки

    me.items = []; //список страниц
    me.settings = []; //настройки

    me.init = function () {
      me.options.$el = $('.favourite-container');
      me.options.$list = me.options.$el.find('.linkslist');
      me.options.$down_up = me.options.$el.find('#favouritepane-down');
      me.options.$add_pane = me.options.$el.find('.favourite-addbox');
      me.options.$del_pane = me.options.$el.find('.favourite-deletebox');
      me.options.$del_btn = me.options.$el.find('#toggleFavouriteDeleteBox');
      me.options.$add_btn = me.options.$el.find('#addToFavourites');
      me.options.$toggle_box = me.options.$el.find('#toggleFavouriteAddBox');
      me.options.$toggle_box_SelectedPosition = me.options.$el.find('#toggleSelectedPositionGrid');
      me.options.$cancel_btn = me.options.$el.find('#cancel');
      me.options.$hide_btn = me.options.$el.find('#hideFavouritesBox');
      me.options.$setFvr_btn = me.options.$el.find('#setFavouritePages');
      me.options.$add_name = me.options.$el.find('#favouriteAddBoxName');
      me.options.$linksbox = me.options.$el.find('.favourite-linksbox');
      me.options.$icondown = me.options.$down_up.find('i');
      me.options.$selectedPositionList = me.options.$el.find('#selectedPosition-data');
      me.initLoadingIndicator();
      if ($(document).find('.favourite-container').length > 0) {
        me.refreshSelectedPositionList();
      }
      me.options.$hide_btn.on('click', function (e) {
        e.preventDefault();
        me.favouriteService.hideSettings().done(function () {
          me.hideWidget();
        }).fail(function (jqXHR, textStatus, errorThrown) {
          $.b2b.errors.showAjaxError(jqXHR);
        });
      });
      me.options.$setFvr_btn.on('click', function (e) {
        e.preventDefault();
        window.location.href = '/PersonalCabinet#favouritePages';
      });
      me.options.$del_btn.on('click', function (e) {
        var url = window.location.pathname + window.location.search;
        var id = me.getIdExists(url);
        if (id !== null) {
          me.updating = true;
          me.favouriteService.remove(id).done(function (data) {
            me.updating = false;
            me.update();
          }).fail(function (jqXHR, textStatus, errorThrown) {
            me.updating = false;
            $.b2b.errors.showAjaxError(jqXHR);
          });
        }
      });
      me.options.$cancel_btn.on('click', function (e) {
        me.options.$add_pane.removeClass('open');
        me.clearName();
      });
      me.options.$add_btn.on('click', function (e) {
        var name = me.options.$add_name.val();
        if (name !== '') {
          // js-событие для цели Я.Метрика. "Подтверждение добавления в Избранное"
          Ya && Ya.reachGoal('SubmitAddingToFavorites');
          me.updating = true;
          me.favouriteService.add(name, me.getCurrentLocation()).done(function (data) {
            me.updating = false;
            me.update();
          }).fail(function () {
            me.updating = false;
            $.b2b.errors.showAjaxError(jqXHR);
          });
        }
      });
      me.options.$down_up.on('click', function (e) {
        var isVisible = me.options.$linksbox.hasClass('autoheight');
        if (!isVisible) {
          me.options.$linksbox.addClass('autoheight');
          me.options.$icondown.switchClass('glyphicon-chevron-down', 'glyphicon-chevron-up');
        } else {
          me.options.$linksbox.removeClass('autoheight');
          me.options.$icondown.switchClass('glyphicon-chevron-up', 'glyphicon-chevron-down');
        }
      });
      me.options.$toggle_box.on('click', function (e) {
        // js-событие для цели Я.Метрика. "Добавить в Избранное"
        Ya && Ya.reachGoal('AddToFavorites');
      });
      me.options.$toggle_box_SelectedPosition.on('click', function (e) {
        // js-событие для цели Я.Метрика. "Отобранные позиции"
        Ya && Ya.reachGoal('Favorites_ViewPositionList');
      });

      //пересчитать видимость стрелки на панели при изменении размера окна
      $(window).on('resize', me.showHideUpDown);

      // Отвязывать всплывающую таблицу с отобранными позициями от автоматического скрытия при клике по ней
      $(document).on('click', 'div.selectedPosition-grid-menu', function (e) {
        e.stopPropagation();
      });
      $(document).on('click', '#selectedPosition-list', me.selectedPositionsListClick);

      // Кнопка быстрых действий
      $(document).on('click', '.selectedPositionFastBtn', me.showFastAdd);

      // Кнопка добавления в корзину
      $(document).on('click', '.catalogBasket:not(".direct-add2cart-event")', me.add2Cart);

      // Отобразить текстовое поле для добавления отобранной позиции
      $(document).on('click', '#positionsSelectionPlaceHolderBtn', me.showPositionsSelectionPlaceHolder);

      // Добавить отобранную позицию
      $(document).on('keyup', '#selectedPositionVendorCode', function (e) {
        if (e.keyCode === 13) {
          me.addPosition();
        }
      });
      $(document).on('click', '#confirmPositionSelectionBtn', me.addPosition);

      // Удалить отобранную позицию
      $(document).on('click', '.deletePosition', function (event) {
        var positionId = $(event.currentTarget).parents('tr').data('positionid');
        me.deleteSelectedPosition(positionId);
      });

      // Событие сокрытия всплывающего окна с отобранными позициями
      $('.selectedPosition-grid').on('hide.bs.dropdown', function () {
        me.clearPopover();
        me.hidePositionsSelectionPlaceHolder();
      });
    };
    me.getCurrentLocation = function () {
      return window.location.pathname + window.location.search;
    };
    me.clearName = function () {
      me.options.$add_name.val('');
    };
    me.checkOverflow = function (el) {
      var curOverflow = el.style.overflow;
      if (!curOverflow || curOverflow === 'visible') el.style.overflow = 'hidden';
      var isOverflowing = el.offsetWidth < el.scrollWidth || el.offsetHeight < el.scrollHeight;
      el.style.overflow = curOverflow;
      return isOverflowing;
    };
    me.showHideUpDown = function () {
      var favoriteBoxElement = me.options.$el.find('.favourite-linksbox').get(0);
      if (favoriteBoxElement && me.checkOverflow(favoriteBoxElement)) {
        me.options.$down_up.removeClass('hidden');
      } else {
        var isVisible = me.options.$linksbox.hasClass('autoheight');
        if (!isVisible) me.options.$down_up.addClass('hidden');
      }
    };
    me.update = function (disableRefresh) {
      if ($(document).find('.favourite-container').length > 0) {
        me.updating = true;
        me.favouriteService.last().done(function (data) {
          me.updating = false;
          if (data.Success) {
            me.items = data.Data.pages;
            me.settings = data.Data.settings;
            if (disableRefresh !== true) {
              me.refresh();
            }
            if (me.updating_callback) {
              me.updating_callback.call(me);
            }
            return;
          }
        }).fail(function (jqXHR, textStatus, errorThrown) {
          me.updating = false;
          $.b2b.errors.showAjaxError(jqXHR);
        });
      }
    };
    me.getUrlExists = function (url) {
      for (var i = 0; i < me.items.length; i++) {
        if (me.items[i].Url === url) {
          return me.items[i].Name;
        }
      }
      return null;
    };
    me.getIdExists = function (url) {
      for (var i = 0; i < me.items.length; i++) {
        if (me.items[i].Url === url) {
          return me.items[i].Id;
        }
      }
      return null;
    };
    me.showDeletePane = function () {
      me.options.$add_pane.addClass('hidden');
      me.options.$del_pane.removeClass('hidden');
    };
    me.showAddPane = function () {
      me.options.$add_pane.removeClass('hidden');
      me.options.$del_pane.addClass('hidden');
    };
    me.showWidget = function () {
      me.options.$el.removeClass('hidden');
    };
    me.hideWidget = function () {
      me.options.$el.addClass('hidden');
    };
    me.clickFavouriteLink = function () {
      // js-событие для цели Я.Метрика "Клик по закладке на плашке Избранное"
      Ya && Ya.reachGoal('Favorites_PageLink');
    };
    me.refresh = function () {
      if (me.options.$el) {
        if (me.updating) {
          // еще идет загрузка с сервера
          me.updating_callback = function () {
            me.refresh();
          };
          return;
        }
        if (me.settings.ShowFavouritePagesWidget === true) {
          me.options.$list.empty();
          //набиваем ссылками
          if (me.items.length > 0) {
            for (var i = 0; i < me.items.length; i++) {
              var $li = $('<li/>');
              var item = me.items[i];
              var additionalStyle = window.location.href.indexOf(item.Url) > -1 ? 'style="color: #1A1F29; font-weight: 600;"' : '';
              var link = $('<a ' + additionalStyle + ' href="' + item.Url + '" title="' + item.Name + '" >' + (item.Name === "Мои заказы" ? item.Name + "<sup style=\"color: red; display: inline-block;\">NEW</sup>" : item.Name) + '</a>');
              link.on('click', me.clickFavouriteLink);
              $li.append(link);
              me.options.$list.append($li);
            }
          }

          //смотрим, а не на ссылке из избранного ль мы находимся
          var url = window.location.pathname + window.location.search;
          var exciting = me.getUrlExists(url);
          if (exciting !== null) {
            //мы на ссылке! Делаем видимой панель удаления, делаем скрытой панель добавления
            me.showDeletePane();
          } else {
            me.showAddPane();
          }
          //отображаем виджет
          me.showWidget();
          me.showHideUpDown();
        } else {
          me.hideWidget();
        }
      }
    };

    // Обновить список отобранных позиций
    me.refreshSelectedPositionList = function (isFromStock) {
      me._loadingIndicator.show();
      $.ajax({
        url: "/SelectedPosition/GetList?isFromStock=".concat(isFromStock),
        type: 'POST',
        success: function success(data) {
          me._loadingIndicator.hide();
          me.options.$selectedPositionList.html(data);
          me.enableSelectedPositionsSorting();
        },
        error: function error(jqXhr) {
          me._loadingIndicator.hide();
          $.b2b.errors.showAjaxError(jqXhr);
        }
      });
    };

    // Добавить позицию
    me.addPosition = function () {
      // js-событие для цели Я.Метрика. "Добавить новую позицию"
      Ya && Ya.reachGoal('Favorites_AddPosition');
      me._loadingIndicator.show();
      $.ajax({
        url: '/SelectedPosition/Add',
        type: 'POST',
        data: {
          vendorCode: $('#selectedPositionVendorCode').val()
        },
        success: function success(data) {
          me._loadingIndicator.hide();
          if (data.Errors) {
            $.b2b.errors.showAjaxError(data.Errors[0]);
          } else {
            me.options.$selectedPositionList.html(data);
            me.enableSelectedPositionsSorting();
          }
        },
        error: function error(jqXhr) {
          me._loadingIndicator.hide();
          $.b2b.errors.showAjaxError(jqXhr);
        }
      });
    };
    me.enableSelectedPositionsSorting = function () {
      $('#selectedPositions-table tbody').sortable({
        items: '> tr',
        handle: '.glyphicon-option-vertical',
        update: function update() {
          var productIds = $('#selectedPositions-table tbody tr').map(function () {
            return $(this).data('productid');
          }).get();
          $.b2b.ajax({
            url: '/SelectedPosition/ReorderProducts',
            type: 'POST',
            data: {
              productIds: productIds
            }
          });
        }
      });
    };

    // Удалить отобранную позицию
    me.deleteSelectedPosition = function (positionId) {
      me._loadingIndicator.show();
      $.ajax({
        url: '/SelectedPosition/Delete',
        type: 'POST',
        data: {
          positionID: positionId
        },
        success: function success(data) {
          me._loadingIndicator.hide();
          me.options.$selectedPositionList.html(data);
          me.enableSelectedPositionsSorting();
        },
        error: function error(jqXhr) {
          me._loadingIndicator.hide();
          $.b2b.errors.showAjaxError(jqXhr);
        }
      });
    };

    // Показать текстовое поле для добавления новой позиции
    me.showPositionsSelectionPlaceHolder = function () {
      $('#positionSelection').removeClass('hidden');
      $('#positionsSelectionPlaceHolderBtn').addClass('hidden');
    };

    // Спрятать текстовое поле для добавления новой позиции
    me.hidePositionsSelectionPlaceHolder = function () {
      $('#positionSelection').addClass('hidden');
      $('#positionsSelectionPlaceHolderBtn').removeClass('hidden');
    };

    // Убрать всплывающие кнопки быстрых действий
    me.clearPopover = function () {
      $('.selectedPositionFastBtn').each(function () {
        $(this).popover('hide');
      });
      $('.catalogBasket').each(function () {
        $(this).popover('hide');
      });
    };
    me.selectedPositionsListClick = function (event) {
      me.hidePositionsSelectionPlaceHolder();
      var target = $(event.target);
      var currentPopover = target.hasClass('popover-content') ? $(target.parents('.popover')[0]) : $($(target.parents('.popover-content')[0]).parents('.popover')[0]);

      // Если кликнули по popover'у то скрывать ничего не надо
      if (currentPopover && currentPopover.length !== 0) {
        event.stopPropagation();
        return;
      }
      me.clearPopover();
      event.stopPropagation();
    };
    me.showFastAdd = function (event) {
      var elem = $(event.target.parentNode);
      if (!elem.prop('haspopover')) {
        $.b2b.fastAddProductWidget.bindSelectedPositionShowFastButton();
      }
      $('.selectedPositionFastBtn').each(function () {
        if (this !== elem[0]) {
          $(this).popover('hide');
        }
      });

      // Скрыть остальные popover'ы
      $('.catalogBasket').each(function () {
        $(this).popover('hide');
      });
      elem.popover('toggle');
      event.stopPropagation();
    };
    me.add2Cart = function (event) {
      event.stopPropagation();
      var elem = $(event.target.parentNode);
      if (!elem.prop('haspopover')) {
        $.b2b.cartWidget.bindAdd2CartEvents();
      }
      $('.catalogBasket').each(function () {
        if (this !== elem[0]) {
          $(this).popover('hide');
        }
      });

      // Скрыть остальные popover'ы
      $('.selectedPositionFastBtn').each(function () {
        $(this).popover('hide');
      });
      elem.popover('toggle');
      event.stopPropagation();
    };

    //Анимация для ожидания загрузки данных
    me.initLoadingIndicator = function () {
      me._loadingIndicator = $('.selectedPosition-loading-indicator');
      new Spinner({
        lines: 7,
        /* The number of lines to draw */
        length: 0,
        /* The length of each line */
        width: 12,
        /* The line thickness */
        radius: 12,
        /* The radius of the inner circle */
        scale: 1,
        /* Scales overall size of the spinner */
        corners: 1,
        /* Corner roundness(0..1) */
        color: '#029AE5',
        /* #rgb or #rrggbb or array of colors */
        opacity: 0.25,
        /* Opacity of the lines */
        rotate: 0,
        /* The rotation offset */
        direction: 1,
        /* 1: clockwise, -1: counterclockwise */
        speed: 1,
        /* Rounds per second */
        trail: 60,
        /* Afterglow percentage */
        fps: 20,
        /* Frames per second when using setTimeout() as a fallback for CSS */
        zIndex: 2e9,
        /* The z - index(defaults to 2000000000) */
        className: 'spinner',
        /* The CSS class to assign to the spinner */
        top: '50%',
        /* Top position relative to parent */
        left: '50%',
        /* Left position relative to parent */
        shadow: false,
        /* Whether to render a shadow */
        hwaccel: false,
        /* Whether to use hardware acceleration */
        position: 'absolute' /* Element positioning */
      }).spin(me._loadingIndicator[0]);
    };
    me.initPopover = function () {
      var popoverEl = $("#favouriteBoxPopover");
      if (popoverEl.length === 0) {
        return;
      }
      var dxPopover = DevExpress.ui.dxPopover;
      me.popover = dxPopover.getInstance(popoverEl[0]);
      if (!me.popover) {
        me.popover = new dxPopover(popoverEl[0], {
          target: "#favourite-about",
          position: {
            at: "bottom",
            my: "right-bottom",
            offset: "0 100"
          },
          width: "auto",
          animation: {
            show: {
              type: "pop",
              from: {
                scale: 0
              },
              to: {
                scale: 1
              }
            },
            hide: {
              type: "fade",
              from: 1,
              to: 0
            }
          }
        });
      }
      $("#favourite-about").off().on({
        mouseover: function mouseover(e) {
          var target = $(e.currentTarget);

          // Не перерисовывать поповер, если курсор находится на той же строке
          if (target[0] === me.popover.option("target")[0] && me.popover.option("visible")) return;
          me.popover.option("contentTemplate", function () {
            return "<div id=\"favourite-about-text\">Панель \"<b>Закладки</b>\" обеспечит Вам быстрый переход на необходимые страницы! " + "</br></br>У Вас есть возможность самим сформировать список вкладок. " + "</br>Чтобы добавить текущую страницу в список, нажмите на \"<b>Добавить в закладки</b>\", введите название вкладки и подтвердите добавление. " + "</br>Чтобы удалить текущую страницу из списка \"<b>Закладки</b>\", нажмите на \"<b>Удалить из закладок</b>\". " + "</br></br>Чтобы скрыть данную панель, нажмите на иконку настроек закладок " + "<span id=\"favourite-about-text-settings-icon\"><i class=\"mdi mdi-cog mdi-18px mdi-theme-color\"></i></span>" + "</br>Вернуть панель обратно Вы сможете через соответствующий раздел личного кабинета.</div>";
          });
          me.popover.option("target", target);
          me.popover.show();

          // js-событие для цели Я.Метрика. "Вызов подсказки панели Избранное"
          Ya && Ya.reachGoal("ViewFavoritesHint");
        },
        mouseleave: function mouseleave(e) {
          me.popover.hide();
        }
      });
    };
  };

  // Запускаем сразу, но отрисуется тогда, когда DOM построен
  var instance = new Widget();
  instance.update(true);
  $(document).ready(function () {
    instance.init();
    instance.refresh();
    // После bootstrap Angular (он регистрируется раньше в document.ready).
    setTimeout(function () {
      instance.initPopover();
    }, 0);
  });
})(jQuery);